const ThermostatsContents = (isEcobee) => {
  let thermostatEnglishName = 'Ecobee';
  let thermostatKoreanName = '에코비';
  if (!isEcobee) {
    thermostatEnglishName = 'Sensi';
    thermostatKoreanName = '센시';
  }
  return {
    en: {
      isEcobee,
      deviceView: {
        choiceText: `Select which ${thermostatEnglishName} Thermostat you’d like your Awair to connect with.`,
        logoutBtnText: `Sign Out of ${thermostatEnglishName}`
      },
      settingView: {
        settingGuideText1: {
          'awair': thermostatEnglishName === 'Ecobee' ? 'Set up your ranges for CO₂, VOCs, and Dust below and let Awair work with Ecobee to help you create healthy and comfortable environment.' : "Set the thresholds for CO₂, VOCs, and Dust that will trigger your home's HVAC fan.",
          'awair-r2': thermostatEnglishName === 'Ecobee' ? 'Set up your ranges for CO₂, VOCs, and Fine Dust below and let Awair work with Ecobee to help you create healthy and comfortable environment.' : "Set the thresholds for CO₂, VOCs, and Fine Dust that will trigger your home's HVAC fan.",
          'awair-omni': thermostatEnglishName === 'Ecobee' ? 'Set up your ranges for CO₂, VOCs, and Fine Dust below and let Awair work with Ecobee to help you create healthy and comfortable environment.' : "Set the thresholds for CO₂, VOCs, and Fine Dust that will trigger your home's HVAC fan.",
          'awair-mint': thermostatEnglishName === 'Ecobee' ? 'Set up your ranges for VOCs and Fine Dust below and let Awair work with Ecobee to help you create healthy and comfortable environment.' : "Set the thresholds for VOCs and Fine Dust that will trigger your home's HVAC fan.",
          'awair-glow': thermostatEnglishName === 'Ecobee' ? 'Set up your ranges for CO₂ and VOCs below and let Awair work with Ecobee to help you create healthy and comfortable environment.' : "Set the thresholds for CO₂ and VOCs that will trigger your home's HVAC fan.",
          'awair-glow-c': thermostatEnglishName === 'Ecobee' ? 'Set up your ranges for VOCs below and let Awair work with Ecobee to help you create healthy and comfortable environment.' : "Set the thresholds for VOCs that will trigger your home's HVAC fan."
        },
        settingGuideText2: isEcobee ? 'Ecobee will trigger the fan for 30 minutes when any one of these conditions are exceeded. Your HVAC system must be on and not set to Away.' : 'Sensi will turn fan circulation to “on” from “auto” mode and run continuously for up to 12 hours.',
        moveAppBtnText: `Go to ${thermostatEnglishName} app`,
        disconnectBtnText: 'Remove All Conditions'
      }
    },
    ko: {
      deviceView: {
        choiceText: `어웨어와 연결하고 싶은 ${thermostatKoreanName}를 선택해 주세요.`,
        logoutBtnText: `${thermostatKoreanName}에서 로그아웃`
      },
      settingView: {
        settingGuideText1: {
          'awair': `아래에서 원하는 이산화탄소, 화학물질, 미세먼지 범위를 설정하세요. 어웨어가 ${thermostatKoreanName}를 통해 건강하고 편안한 실내환경을 만들어 드립니다.`,
          'awair-r2': `아래에서 원하는 이산화탄소, 화학물질, 초미세먼지 범위를 설정하세요. 어웨어가 ${thermostatKoreanName}를 통해 건강하고 편안한 실내환경을 만들어 드립니다.`,
          'awair-omni': `아래에서 원하는 이산화탄소, 화학물질, 초미세먼지 범위를 설정하세요. 어웨어가 ${thermostatKoreanName}를 통해 건강하고 편안한 실내환경을 만들어 드립니다.`,
          'awair-mint': `아래에서 원하는 화학물질, 초미세먼지 범위를 설정하세요. 어웨어가 ${thermostatKoreanName}를 통해 건강하고 편안한 실내환경을 만들어 드립니다.`,
          'awair-glow': `아래에서 원하는 이산화탄소, 화학물질 범위를 설정하세요. 어웨어가 ${thermostatKoreanName}를 통해 건강하고 편안한 실내환경을 만들어 드립니다.`,
          'awair-glow-c': `아래에서 원하는 화학물질 범위를 설정하세요. 어웨어가 ${thermostatKoreanName}를 통해 건강하고 편안한 실내환경을 만들어 드립니다.`
        },
        settingGuideText2: `${thermostatKoreanName}에서 설정한 시간동안 팬이 자동으로 돌게 됩니다. ${thermostatKoreanName}가 온라인 상태이며 Away 상태가 아니어야 작동합니다.`,
        moveAppBtnText: `${thermostatKoreanName} 앱으로 이동하기`,
        disconnectBtnText: '모든 설정 초기화'
      }
    }
  }
};

export default ThermostatsContents;


// WEBPACK FOOTER //
// ./src/assets/contents/thermostats.js